module.exports = __webpack_public_path__ + "static/media/logo_bacabank.5692f3e1.svg";